module.exports = __webpack_public_path__ + "img/myrarget.d3bbaa01.svg";